import { render } from "./invite-talents-modal.vue?vue&type=template&id=d2ab63ba&ts=true"
import script from "./invite-talents-modal.vue?vue&type=script&lang=ts"
export * from "./invite-talents-modal.vue?vue&type=script&lang=ts"

import "./invite-talents-modal.vue?vue&type=style&index=0&id=d2ab63ba&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__